import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../../services/exports/Constants';

export default {
  title: {
    [ORDER_METHODS.DELIVERY]: 'Dostawa',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Obsługa pokoju',
      [RoomServiceLocationType.TableService]: 'Obsługa przy stole',
    },
  },
  form: {
    doorbell_name: {
      placeholder: 'Nazwa dzwonka (opcjonalnie)',
    },
    company_name: {
      placeholder: 'Nazwa firmy (opcjonalnie)',
    },
    customer_note: {
      placeholder: 'Instrukcje dostawy (opcjonalnie)',
    },
    order_instructions: {
      placeholder: 'Wpisz instrukcje do zamówienia...',
    },
  },
};
